module.exports = __webpack_public_path__ + "1c7b6e132d288697fb64e99426f87806.pdf";